import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

type RouterLinkProps = Omit<LinkProps, 'to'> & {
  href: string;
};

export const RouterLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(({ href, ...rest }, ref) => {
  return <Link ref={ref} to={href} {...rest} />;
});

RouterLink.displayName = 'RouterLink';
